/* @format */

import store from '@/stores';
import EventBus from '@/scripts/event-bus';

/**
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {function} next
 */
export function accountReactivateGuard(to, from, next) {
    const defaultRedirectPath = '/';

    const client = store.state.context.client;
    const isClientUser = store.getters.isClientUser;
    const isAdmin = store.getters.isAdmin;

    if (!isClientUser) {
        return next(defaultRedirectPath);
    }

    if (client.isActive) {
        EventBus.$emit('already-activated');
        return next(defaultRedirectPath);
    }

    if (!isAdmin) {
        return next({
            name: 'ReactivateAccountContact',
        });
    }

    next();
}
